import { render, staticRenderFns } from "./fileAssessment.vue?vue&type=template&id=5a6fc870&"
import script from "./fileAssessment.vue?vue&type=script&lang=js&"
export * from "./fileAssessment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports